import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-sm-12" }
const _hoisted_9 = { class: "form-group mb-2" }
const _hoisted_10 = { class: "d-block mt-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "d-flex align-items-start justify-content-between mt-4 mb-5"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "text-center mt-3" }
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Edit Production Process",
          text: "Edit Production Process"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_localized_text, {
              type: "label",
              localizedKey: "Production Process",
              text: "Production Process"
            }),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.productionProcessName), 1)
          ])
        ])
      ]),
      _hoisted_11,
      (_ctx.model.productionProcessIdentifier)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRawMaterials, (rawMaterial) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "text-center mx-4",
                key: rawMaterial.identifier
              }, [
                _createElementVNode("strong", null, _toDisplayString(rawMaterial.text), 1),
                (_ctx.model.rawMaterialCountryAndUnits[rawMaterial.identifier])
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.countries.filter(x => x.identifier == _ctx.model.rawMaterialCountryAndUnits[rawMaterial.identifier].key)[0].text), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_14, "---")),
                _createElementVNode("div", {
                  class: _normalizeClass(["sameAsCheckbox pointer mx-auto mt-2", { active: Object.keys(_ctx.model.rawMaterialCountryAndUnits).indexOf(rawMaterial.identifier) != -1 }]),
                  onClick: ($event: any) => (_ctx.addOrRemoveRawMaterial(rawMaterial.identifier))
                }, null, 10, _hoisted_15)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: _ctx.disabled,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Edit",
            text: "Edit"
          })
        ], 8, _hoisted_17)
      ])
    ])
  ]))
}